import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Register service worker for push notifications and offline scaffolding.
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // best-effort — push will simply stay disabled if registration fails
    });

    // Listen for messages from the SW (e.g. play sound on push)
    navigator.serviceWorker.addEventListener('message', (event) => {
      const msg = event.data as { type?: string; sound?: string; url?: string } | undefined;
      if (!msg) return;
      if (msg.type === 'tapnpay-push-sound' && msg.sound) {
        try {
          const audio = new Audio(msg.sound);
          audio.play().catch(() => undefined);
        } catch {
          // ignore
        }
      } else if (msg.type === 'tapnpay-push-navigate' && msg.url) {
        try {
          window.location.assign(msg.url);
        } catch {
          // ignore
        }
      }
    });
  });
}
